import { zipObject, get } from 'lodash';
import { getAllLeafPaths } from '@schoolbelle/common/object-change-tracker';
export function flatObject(ob: Object): { [key: string]: any } {
  const paths = getAllLeafPaths(ob);
  return zipObject(paths, paths.map(path => get(ob, path)));
}
